import React from "react";
import styles from '@/public/styles/common/content.module.scss'
import Link from 'next/link'

interface BreadcrumbsItemI {
    path: string
    title: string
    asPath?: string
    disabled?: boolean
}

interface BreadcrumbsI {
    items: BreadcrumbsItemI[]
}

const Breadcrumbs = (props: BreadcrumbsI) => {
    const {items} = props

    function getItems() {
        let crumbs = items.map((item, i) => {
            if (!item.path) {
                return ;
            }

            let result =  `{
                "@type": "ListItem",
                "position": ${i+2},
                "item":
                    {
                        "@id": "${item.path}",
                        "name": "${item.title}"
                    }
                }`

            result = ',' + result

            return result
        })

        let result = ''
        for (const crumb of crumbs) {
            if (crumb) {
                result += crumb
            }
        }

        return result
    }

    return (
        <div className={styles.breadCrumbs}>
            <ul>
                <li><Link prefetch={false} href="/" as="/"><a>Главная</a></Link></li>
                {items?.filter(el => el?.title)?.map((breadcrumb, i) => (
                    <li key={breadcrumb.path}>
                        {!breadcrumb.disabled && <Link prefetch={false}
                            href={breadcrumb.path}
                            as={breadcrumb.asPath || breadcrumb.path}
                        >
                            <a>{breadcrumb?.title}</a>
                        </Link>
                        }
                        {breadcrumb.disabled === true &&
                        <>{breadcrumb?.title}</>
                        }
                    </li>
                ))}
            </ul>


            <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{
                    __html: `
                    {
                        "@context": "https://schema.org",
                        "@type": "BreadcrumbList",
                        "itemListElement":
                            [
                                {
                                     "@type": "ListItem",
                                     "position": 1,
                                     "item":
                                        {
                                            "@id": "https://wayout.fitness",
                                            "name": "Главная"
                                        }
                                }
                                ${getItems()}
                            ]
                    }`
                }}
            />
        </div>
    );
};

export default Breadcrumbs
